export class Vehicle {
    id?: number;
    capacity?: number;
    year?: number;
    registerNumber?: string;
    enterprise?: number;
    model?: IModel;
}

export class IModel{
    id?: number;
    description?: string;
    brand?: IBrand;
}

export class IBrand{
    id?: number;
    description?: string;
    models?: IModel[];
}

